import { LAYOUT_STATE, ServerWebsocketData } from "./SiteStateTypes";

export const mockWebsocketReturns: ServerWebsocketData[] = [
    {
        "phoneNumber": 8148155483,
        "dynamicSiteState": {
            "layoutState": LAYOUT_STATE.PHONE_NUMBER,
            "layoutBasedState": {
            }
        }
    },
    {
        "phoneNumber": 8148155483,
        "dynamicSiteState": {
            "layoutState": LAYOUT_STATE.PROJECT_LIST,
            "layoutBasedState": {
                "projectListState": {
                    filteredProjects: {
                        "Phonefolio": true,
                        "Ouroboros": true,
                    }
                }
            }
        }
    },
    {
        "phoneNumber": 8148155483,
        "dynamicSiteState": {
            "layoutState": LAYOUT_STATE.PROJECT_LIST,
            "layoutBasedState": {
                "projectListState": {
                    filteredProjects: {
                        "Phonefolio": true,
                    }
                }
            }
        }
    },
    {
        "phoneNumber": 8148155483,
        "dynamicSiteState": {
            "layoutState": LAYOUT_STATE.SINGLE_PROJECT,
            "layoutBasedState": {
                "singleProjectState": {
                    currentProjectKey: "Phonefolio"
                }
            }
        }
    },
    {
        "phoneNumber": 8148155483,
        "dynamicSiteState": {
            "layoutState": LAYOUT_STATE.SINGLE_PROJECT,
            "layoutBasedState": {
                "singleProjectState": {
                    currentProjectKey: "Ouroboros"
                }
            }
        }
    },
]